export default __webpack_public_path__ + "static/media/positionly.629f9386.svg";